import React from 'react';
import styles from './Resume.module.scss';
import { ResumeHeader } from './ResumeHeader';
import { SectionWrapper } from './Section';
import { SummaryDevops, SummaryFrontend, Education, Languages, FrontendSkills, DevopsSkills } from './Sections';
import { Experience } from './Sections/Experience';

export const Resume = () => {
    const printDate = new Intl.DateTimeFormat('en-GB', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
    }).format(new Date());
    const isFrontendResume = Boolean(process.env.REACT_APP_FRONTEND_RESUME);

    return (
        <main className={styles.resume}>
            <ResumeHeader data-testid='resumeHeader' />
            {/* <div className={styles.websiteLink + ' only-print'}>
                Please check my up2date resume at: <a>{process.env.REACT_APP_FRONTEND_RESUME ? 'https://burakbal.com' : 'https://burakbal.com'}</a>
            </div> */}
            {isFrontendResume ? (
                <SectionWrapper className={styles.frontendSectionWrapper}>
                    <SummaryFrontend
                        className={`${styles.summarySection} ${styles.frontendSummarySection}`}
                        data-testid='summaryFrontend'
                    />
                    <FrontendSkills className={styles.frontendSkillsSection} data-testid='frontendSkills' />
                    <Experience className={styles.frontendExperienceSection} data-testid='experience' />
                    <Education className={styles.frontendEducationSection} data-testid='education' />
                    <Languages className={styles.frontendLanguagesSection} data-testid='languages' />
                </SectionWrapper>
            ) : (
                <SectionWrapper>
                    <div className={styles.sectionLeft} style={{ '--font-size': '0.7rem' }}>
                        <SummaryDevops className={styles.summarySection} data-testid='summaryDevops' />
                        <Education data-testid='education' />
                        <DevopsSkills data-testid='devopsSkills' />
                        <FrontendSkills data-testid='frontendSkills' />
                        <Languages data-testid='languages' />
                    </div>

                    <div className={styles.sectionRight}>
                        <Experience data-testid='experience' />
                    </div>
                </SectionWrapper>
            )}
            <footer className={`${styles.printFooter} only-print`}>
                <span>{printDate}</span>
                <span aria-hidden='true'>–</span>
                <a href='https://burakbal.com'>https://burakbal.com</a>
            </footer>
        </main>
    );
};
